import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 68 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={68}
      height={52}
      fill="white"
    />
    <rect
      x={8.5}
      y={8.5}
      width={51}
      height={32}
      rx={1.5}
      stroke="#29292F"
    />
    <rect
      x={12.5}
      y={15.5}
      width={43}
      height={21}
      rx={0.5}
      fill="#FFE6ED"
      stroke="#FFD5E1"
    />
    <rect
      x={6}
      y={43}
      width={56}
      height={1}
      rx={0.5}
      fill="#29292F"
    />
    <circle
      cx={35}
      cy={12}
      r={0.5}
      stroke="#29292F"
    />
  </svg>
);
const SvgDesktopDevice = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDesktopDevice;
